import React, { useEffect, useState } from 'react';
import { FiArrowLeft, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '../../../design-system';
import { ProductSearchResults } from './ProductSearchResults';
import { ProductSummary } from './product';

interface SearchProduct extends ProductSummary {
  link: string;
  is_same_city?: boolean;
  is_vendor_online?: boolean;
  is_best_vendor?: boolean;
}

interface ShowMoreProductResultsProps {
  products: SearchProduct[];
  onProductClick: (productId: number) => void;
  agent_chat_id?: number;
}

export const ShowMoreProductResults: React.FC<ShowMoreProductResultsProps> = ({ products, onProductClick, agent_chat_id }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    const close = (event: KeyboardEvent) => event.key === 'Escape' && setIsOpen(false);
    document.addEventListener('keydown', close);
    return () => document.removeEventListener('keydown', close);
  }, [isOpen]);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="flex h-11 w-full items-center justify-center gap-2 rounded-ds-6 border border-ds-primary bg-ds-primary text-xs font-bold text-white transition-colors hover:bg-ds-primary-strong app-sm:w-auto app-sm:px-6"
      >
        مشاهده {products.length.toLocaleString('fa-IR')} محصولات بیشتر <FiChevronLeft />
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex flex-col bg-ds-canvas">
          <header className="flex h-[58px] shrink-0 items-center gap-3 border-b border-ds-100 bg-ds-white px-3 app-sm:h-[72px] app-sm:px-6">
            <IconButton onClick={() => setIsOpen(false)} aria-label="بازگشت"><FiArrowLeft className="rtl-flip" /></IconButton>
            <div className="min-w-0">
              <h2 className="truncate text-sm font-bold text-ds-ink">بقیه نتایج</h2>
              <p className="mt-1 text-[10px] text-ds-500">{products.length.toLocaleString('fa-IR')} محصول</p>
            </div>
          </header>
          <main className="ds-scrollbar min-h-0 flex-1 overflow-y-auto p-3 app-sm:p-6">
            <div className="mx-auto max-w-[1120px]">
              <ProductSearchResults products={products} onProductClick={onProductClick} agent_chat_id={agent_chat_id} />
            </div>
          </main>
        </div>
      )}
    </>
  );
};
